import { Box, Tab, Tabs } from "@mui/material";
import __ from "src/utils/Translations";
import { NavLink, useLocation } from "react-router-dom";
import { FC } from "react";
import { OrgchartType } from "src/Pages/Company/OrganizationStructure/ConfigureStructure/Tabs/StructureView/FilterBar.models";

const PreviewStructures: FC = () => {
  const location = useLocation();

  const baseUrl = location.pathname.split("/structure-")[0];

  const areaPath = `${baseUrl}/structure-areas`;
  const viewPath = `${baseUrl}/structure-view/${OrgchartType.Areas}`;
  const settingsPath = `${baseUrl}/structure-settings`;

  const tabs = [
    { label: __("Obszary"), path: areaPath },
    { label: __("Podgląd struktury"), path: viewPath },
    { label: __("Ustawienia"), path: settingsPath },
  ];
  const isViewTab = location.pathname.includes("/structure-view/");
  const activeTab = isViewTab
    ? viewPath
    : tabs.find((tab) => location.pathname.startsWith(tab.path))?.path ?? false;

  return (
    <Box sx={{ margin: "22px 0" }}>
      <Tabs
        value={activeTab}
        sx={{
          "& .MuiTab-root": {
            textTransform: "uppercase",
            "&:hover": { textDecoration: "none" },
          },
        }}
      >
        {tabs.map((tab) => (
          <Tab
            key={tab.path}
            label={tab.label}
            component={NavLink}
            to={tab.path}
            value={tab.path}
          />
        ))}
      </Tabs>
    </Box>
  );
};

export default PreviewStructures;
